import { render, staticRenderFns } from "./YetaiZiyuanFenxiDetail.vue?vue&type=template&id=6aac8d87&scoped=true&"
import script from "./YetaiZiyuanFenxiDetail.vue?vue&type=script&lang=js&"
export * from "./YetaiZiyuanFenxiDetail.vue?vue&type=script&lang=js&"
import style0 from "./YetaiZiyuanFenxiDetail.vue?vue&type=style&index=0&id=6aac8d87&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6aac8d87",
  null
  
)

export default component.exports